<template>
  <v-card>
    <v-card-title v-if="options.title">
      <span class="headline">{{ options.title }}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <ValidationObserver
        ref="form"
        tag="form"
        @submit.prevent="save"
      >
        <ValidationProvider
            rules="required"
            vid="name"
            :name="$t('fields.name').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.name"
            :counter="30"
            :label="$t('fields.name')"
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>
        <ValidationProvider
            rules="numeric"
            vid="printOrder"
            :name="$t('fields.print_order').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.printOrder"
            :label="$t('fields.print_order')"
            :error-messages="errors"
          ></v-text-field>

          </ValidationProvider>

          <v-checkbox
            v-model="form.is_primary"
            :label="$t('fields.primary_school')"
            :true-value="1"
            hide-details
          ></v-checkbox>

          <v-checkbox
              v-model="form.is_secondary"
              :label="$t('fields.secondary_school')"
              :true-value="1"
              hide-details
          ></v-checkbox>


    </ValidationObserver>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="save" color="primary">{{ $t('SAVE') }}</v-btn>
      <v-btn @click="cancel">{{ $t('CANCEL') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
  import { mapActions, mapState } from 'vuex';

  import { subjectsService } from '../../../utils/services/subjects.service';

  export default {
    name: 'SubjectModal',
    data() {
      return {
        stored: null,
        subject: {},
        form: {
          name: null,
          is_primary: null,
          is_secondary: null,
          printOrder: null,
        },
        loading: false,
      };
    },
    computed: {
      ...mapState('modal', ['options', 'data']),
    },
    methods: {
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['hideModal', 'loadingModal']),
      async save() {
        const isValid = await this.$refs.form.validate();
        if (isValid) {
            if (this.options.onSave) {
              this.loadingModal(true);
              this.options.onSave(
                this.form,
                this.errors,
              )
              .then(() => {
                  this.loadingModal(false);
              })
              .catch(error => {
                  this.handleError(error, this.errors);
              });
            }
        }
      },
      cancel() {
        this.hideModal({});
      },
      fetchSubject(id) {
        return subjectsService.get(id)
        .then(response => {
            this.subject = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },
    },
    async created() {
      this.loadingModal(true);
      if (this.data.stored.id) {
        await this.fetchSubject(this.data.stored.id);
        this.form = {
          id: this.data.stored.id,
          name: this.subject.name,
          is_primary: (this.subject.options && this.subject.options.is_primary) ? 1 : 0,
          is_secondary: (this.subject.options && this.subject.options.is_secondary) ? 1 : 0,
          printOrder: (this.subject.options && this.subject.options.printOrder) ? this.subject.options.printOrder : null,
        };
      }
      this.loadingModal(false);
    },
  };
</script>
